import { render, staticRenderFns } from "./SoftwareProjects.vue?vue&type=template&id=3a894b2c&scoped=true"
import script from "./SoftwareProjects.vue?vue&type=script&lang=js"
export * from "./SoftwareProjects.vue?vue&type=script&lang=js"
import style0 from "./SoftwareProjects.vue?vue&type=style&index=0&id=3a894b2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a894b2c",
  null
  
)

export default component.exports